module.exports = __webpack_public_path__ + "img/product-core-5.d59017fd.png";